import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import Moment from "react-moment";
import { URL_LIST_ALL } from "../configs/api";
import Spinner from "../component/Spinner";
import ModalXemFile from "./ModalXemFile";

/**
 * Xem nhanh các hợp đồng của 1 nhân sự, mở từ form thông tin nhân sự.
 *
 * Dùng bộ lọc f_user_id của hook api/more/hopdong.php (đã có sẵn cho màn hình
 * danh sách hợp đồng) nên không phải thêm gì ở backend.
 */
export default function ModalHopDongNhanSu({ show, onHide, userId, userName }) {
    const { user } = useSelector((state) => state.auth);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [viewing, setViewing] = useState(null);

    useEffect(() => {
        if (!show || !userId) return;
        let cancelled = false;
        setLoading(true);
        setError("");

        Axios.get(URL_LIST_ALL + "hopdong?limit=100&f_user_id=" + encodeURIComponent(userId), user.config)
            .then((res) => {
                if (cancelled) return;
                if (res.data.status === "success") setRows(res.data.data || []);
                else setError(res.data.message || "Không tải được danh sách hợp đồng");
            })
            .catch((err) => {
                if (!cancelled) setError(err?.response?.data?.message || err.message || "Lỗi kết nối");
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => { cancelled = true; };
    }, [show, userId, user.config]);

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" animation={true}>
                <Modal.Header closeButton>
                    <Modal.Title className="h6 mb-0">
                        Hợp đồng của nhân sự{userName ? ": " + userName : ""}
                        {rows.length > 0 && <span className="badge badge-info ml-2">{rows.length}</span>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading && (
                        <div className="w-100 d-flex justify-content-center py-4">
                            <Spinner />
                        </div>
                    )}
                    {error && <div className="alert alert-danger">{error}</div>}

                    {!loading && !error && rows.length === 0 && (
                        <div className="alert alert-warning mb-0">
                            Nhân sự này chưa có hợp đồng nào.
                        </div>
                    )}

                    {!loading && rows.length > 0 && (
                        <table className="table table-sm table-bordered table-hover mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th style={{ width: 50 }}>#</th>
                                    <th>Tiêu đề</th>
                                    <th>Loại hợp đồng</th>
                                    <th style={{ width: 130 }}>Ngày tạo</th>
                                    <th style={{ width: 120 }}>File</th>
                                    <th style={{ width: 80 }}>Chi tiết</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, i) => (
                                    <tr key={row.id}>
                                        <td>{i + 1}</td>
                                        <td>{row.title}</td>
                                        <td>{row.type_name}</td>
                                        <td>
                                            {row.datecreate ? (
                                                <Moment format="DD/MM/YYYY">{new Date(row.datecreate * 1000)}</Moment>
                                            ) : ""}
                                        </td>
                                        <td>
                                            {row.file_url ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => setViewing(row)}
                                                >
                                                    <span className="fas fa-eye"></span> Xem file
                                                </button>
                                            ) : (
                                                <span className="text-muted">Chưa có</span>
                                            )}
                                        </td>
                                        <td>
                                            <Link
                                                to={"/edit-hop-dong/" + row.id}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="btn btn-sm btn-info"
                                                title="Mở trang hợp đồng ở tab mới"
                                            >
                                                <span className="fas fa-external-link-alt"></span>
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-sm btn-secondary" onClick={onHide}>
                        Đóng
                    </button>
                </Modal.Footer>
            </Modal>

            <ModalXemFile
                show={!!viewing}
                onHide={() => setViewing(null)}
                url={viewing ? viewing.file_url : ""}
                title={viewing ? viewing.title : ""}
            />
        </>
    );
}
